<span class="p-float-label">
    <input pInputText class="p-inputtext-sm" [id]="id" (input)="onInput($event)"
           [value]="formControl['value']" [disabled]="formControl['disabled']"/>
    <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label"></label>
    <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                          [required]="formControl.errors?.['required']"
                          [email]="formControl.errors?.['email']"
                          [wrongPhone]="formControl.errors?.['wrongPhone']"></app-form-input-error>
</span>
